export const toEndYearMonth = dateInput => {
  if (!dateInput) return '';

  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');

  return `${year}-${month}`;
};

export const formatEndYearMonth = endYearMonth => {
  if (!endYearMonth || !/^\d{4}-\d{2}$/.test(endYearMonth)) {
    return endYearMonth || '';
  }

  const [year, month] = endYearMonth.split('-').map(Number);
  const date = new Date(year, month - 1, 1);

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric'
  }).format(date);
};

export const formatEvaluationInterval = (
  startYearMonth,
  endYearMonth,
  { separator = ' to ', fallback = '' } = {}
) => {
  const formattedStartYearMonth = formatEndYearMonth(startYearMonth);
  const formattedEndYearMonth = formatEndYearMonth(endYearMonth);

  if (formattedStartYearMonth && formattedEndYearMonth) {
    return `${formattedStartYearMonth}${separator}${formattedEndYearMonth}`;
  }

  return formattedEndYearMonth || formattedStartYearMonth || fallback;
};

export const sortEndYearMonthsDesc = (months = []) =>
  [...new Set((months || []).filter(Boolean))].sort((a, b) => {
    if (a === b) return 0;
    return a < b ? 1 : -1;
  });
